module.exports = __webpack_public_path__ + "img/TIMES-CIRCLE.d22e04eb.svg";